import { render, staticRenderFns } from "./StopKnop.vue?vue&type=template&id=12be8aaa&scoped=true&"
import script from "./StopKnop.vue?vue&type=script&lang=js&"
export * from "./StopKnop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12be8aaa",
  null
  
)

export default component.exports